<script setup>
import { MAX_ALTITUDE } from '/utils/constants'

const props = defineProps({
  progress: {
    type: Number,
    required: true,
  },
})

const distance = computed(() => {
  const rawDistance = MAX_ALTITUDE - MAX_ALTITUDE * props.progress

  return new Intl.NumberFormat('en-US', {
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
  }).format(rawDistance)
})
</script>

<template>
  <div class="scroll-distance">
    <Icon name="chevron-left" class="scroll-distance__icon" />
    <p>{{ distance }} FT.</p>
  </div>
</template>

<style lang="scss">
@use 'sass:math';

// Utils
@import '~/styles/utils/variables';

.scroll-distance {
  color: $brand-white;
  display: inline-flex;
  align-items: center;
  transform: rotate(-90deg);
  transform-origin: top left;

  &__icon {
    color: $brand-blue;
    width: 12px;
    height: 12px;
  }

  p {
    font-variant-numeric: tabular-nums;
    font-size: 10px;
    font-weight: $font-weight-4G;
    line-height: math.div(15, 10);
    letter-spacing: 0.27em;
    text-transform: uppercase;
    margin-left: 5px;
  }
}
</style>
